import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import AwsExports from "./aws-exports";
import VueSimpleSVG from 'vue-simple-svg';
import Vue from 'vue';

import "./registerServiceWorker";
import './plugins/vuetify';

import App from './App.vue';
import router from './router';
import store from "./store";

Amplify.configure(AwsExports);

Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(VueSimpleSVG)

Vue.config.productionTip = false;

const requireComponent = require.context("./components/@global", false, /App[A-Z]\w+\.(vue|js)$/);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, "$1");
  Vue.component(componentName, componentConfig.default || componentConfig);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
